import TabContentProvider from './hooks/useTabContent';

import { TabContentProps } from './@types/TabContentProps';

const TabContent = (props: TabContentProps) => <TabContentProvider {...props}>{props.children}</TabContentProvider>;

export default TabContent;
